import { SearchParams } from 'typesense/lib/Typesense/Documents';
import { typesenseClient } from '../typesense';
import { SiteCost } from '../models/SiteCost';

export async function getSiteCost(): Promise<SiteCost> {
    try {
        const searchParams: SearchParams = {
            q: "*",
            limit: 1,
            sort_by: "createdDate:desc"
        };

        const results = await typesenseClient
            .collections<SiteCost>("server-cost")
            .documents()
            .search(searchParams);

        if (!results.hits) {
            var now = new Date();
            return {
                createdDate: now.getTime(),
                debuff: 0,
                level: 0,
                month: now.getMonth(),
                progress: 0,
                time: 0,
                year: now.getFullYear()
            }
        }

        return results.hits[0].document;
    } catch (e) {
        var now = new Date();
        return {
            createdDate: now.getTime(),
            debuff: 0,
            level: 0,
            month: now.getMonth(),
            progress: 0,
            time: 0,
            year: now.getFullYear()
        }
    }
}